import IconHOC from '../IconHOC';

import { ReactComponent as CheckIcon } from './check.svg';

export const Check = IconHOC(CheckIcon);
